import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URL from "helpers/url_helper";
import { post } from "helpers/api_helper";

export const getGroupSummaryList = createAsyncThunk(
  "getGroupSummaryList",
  async ({ data, callback }, Thunk) => {
    console.log(data, "data======chemist payload");
    try {
      let response = await post(`${URL.GET_GROUP_SUMMARIZATION_LIST}`, data);
      console.log("response callback==>", response);
      callback && callback(null, response);
      return response;
    } catch (error) {
      console.log(error, "error message ");
      callback && callback(error);
      return Thunk.rejectWithValue(error);
    }
  }
);
